import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSite } from "@/lib/i18n";
import { getConsent, loadGA } from "@/lib/analytics";

export function WhatsAppButton() {
  const { site } = useSite();
  const num = (site.whatsapp_number || "").replace(/\D/g, "");
  if (!num) return null;
  const href = `https://wa.me/${num}?text=${encodeURIComponent(site.whatsapp_message || "")}`;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float-btn" aria-label="Escribir por WhatsApp"
      className="fixed bottom-6 right-6 z-50 grid h-16 w-16 place-items-center rounded-full bg-[#25D366] text-white shadow-xl shadow-emerald-600/30 transition-transform duration-300 hover:scale-110">
      <span className="pulse-ring absolute inset-0 rounded-full border-2 border-[#25D366]" aria-hidden="true" />
      <svg viewBox="0 0 32 32" className="relative h-9 w-9" fill="currentColor" aria-hidden="true">
        <path d="M16.004 3C8.82 3 3 8.82 3 16c0 2.29.6 4.53 1.74 6.5L3 29l6.68-1.75A12.94 12.94 0 0 0 16.004 29C23.18 29 29 23.18 29 16S23.18 3 16.004 3Zm0 23.62c-1.98 0-3.92-.53-5.61-1.54l-.4-.24-3.96 1.04 1.06-3.86-.26-.4A10.6 10.6 0 0 1 5.38 16c0-5.86 4.77-10.62 10.63-10.62 5.85 0 10.61 4.76 10.61 10.62 0 5.85-4.76 10.62-10.62 10.62Zm5.83-7.95c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.72.16-.21.32-.82 1.04-1.01 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.89-1.78-2.21-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.18.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.66s1.14 3.09 1.3 3.3c.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.89-.77 2.15-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37Z" />
      </svg>
    </a>
  );
}

export function CookieBanner() {
  const [shown, setShown] = useState(!getConsent());
  const { pathname } = useLocation();
  if (!shown || pathname.startsWith("/admin")) return null;
  const choose = (v) => {
    localStorage.setItem("cc_consent", v);
    if (v === "all") loadGA();
    setShown(false);
  };
  return (
    <div role="dialog" aria-label="Preferencias de cookies" data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-2xl rounded-2xl border border-slate-200 bg-white/95 p-5 shadow-2xl backdrop-blur-md md:right-auto">
      <p className="text-sm text-slate-600">
        Usamos cookies necesarias para el funcionamiento del sitio y, con su consentimiento, cookies de analítica para mejorar la experiencia.{" "}
        <Link to="/legal/privacy" className="text-brand underline">Política de privacidad</Link>.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button onClick={() => choose("all")} className="btn-cc !py-2" data-testid="cookie-accept-all">Aceptar todas</button>
        <button onClick={() => choose("necessary")} className="btn-ghost-cc !py-2 border-slate-300 text-slate-700 hover:bg-slate-50" data-testid="cookie-necessary-only">Solo necesarias</button>
      </div>
    </div>
  );
}
